// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react'
import { Flex, Text, Button, Dialog, PortalOverlay, Toast } from '@leverege/ui-elements'
import { Attributes } from '@leverege/ui-attributes'
import CameraScreen from '../../../imageCapture/CameraScreen'
import { resizeImage, handlePlyLayerOverride } from '../Util'

import S from '../PlyLayerShopFloor.css'

export default function PlyLayerEditor( props ) {
  const { type, onClose, plyLayer, options, locationId, shellId, subAssemblyJobId, userInfo, isNextSA } = props
  const [ selectedIssue, setSelectedIssue ] = useState( '' )
  const [ isEditing, setIsEditing ] = useState( false )
  const [ imageUrl, setImageUrl ] = useState( null )
  const resourcePath = type !== 'Tolerance' ? 'resourceImage/ocr/matchImage' : 'resourceImage/human/tolerance'
  const attributePath = type !== 'Tolerance' ? 'ocr/matchSource' : 'placement/toleranceSource'
  const statusSource = 'humanInput'
  const instructionsText = type !== 'Tolerance' ? 'Position the Label in the Frame' : 'Position Ply Edge in Frame'

  const title = type === 'Tolerance' ?
    `Manually Verify ${Attributes.get( 'name', plyLayer )} Ply Tolerance` :
    `Manually Verify ${Attributes.get( 'name', plyLayer )} Label`

  const handleOpenCamera = () => {
    setIsEditing( true )
  }

  const handleCloseCamera = () => {
    setIsEditing( false )
  }

  const handleSetImage = async ( newImg ) => {
    setImageUrl( newImg )
    setIsEditing( false )
  }

  const handleSubmit = async () => {
    const plyId = plyLayer?.id || null
    const response = await fetch( imageUrl )
    const blob = await response.blob()
    const file = new File( [ blob ], 'image.jpg', { type : 'image/jpeg' } )

    if ( plyId ) {
      try {
        // Resize and convert to base64
        const base64Data = await resizeImage( file )
        
        await handlePlyLayerOverride( {
          file : {
            data : base64Data,
            type : 'image/jpeg',
            name : 'image.jpg'
          },
          userInfo,
          plyId,
          locationId,
          type,
          selectedIssue,
          resourcePath,
          attributePath,
          statusSource,
          shellId,
          subAssemblyJobId,
          isNextSA
        } )
      } catch ( err ) {
        console.error( 'Error processing image:', err )
        Toast.error( 'Failed to process image' )
      }
    } else {
      console.error( 'No layer ID present' )
      Toast.error( 'No layer ID present' )
    }
    onClose()
  }

  if ( isEditing ) {
    return (
      <PortalOverlay
        show={isEditing}
        position="full"
        className={S.cameraDialog}>
        <CameraScreen
          onClose={handleCloseCamera}
          setFormImage={handleSetImage}
          showAspectRatioButtons={false}
          instructionsText={instructionsText}/>
      </PortalOverlay>
      
    )
  }

  const buttons = [
    <Button variant="secondary" key="cancel" onClick={onClose}>Cancel</Button>,
    <Button 
      key="submit"
      variant="primary"
      onClick={handleSubmit}
      disabled={!selectedIssue || !imageUrl}>
      Update Ply Layer
    </Button>
  ]

  return (
    <Dialog
      show
      title={title}
      buttons={buttons}
      onClose={onClose}
      icon="fa-solid fa-layer-plus">
      <Flex variant='colM' className={S.dialogBody}>
        <Text variant="label">{`${type} Verification Image`}</Text>
        { !imageUrl ? (
          <Button variant="primary" className={S.takePhotoButton} onClick={handleOpenCamera}>
            Take Photo
          </Button>
        ) : (
          <Flex direction="column" align="flex-start">
            <div className={S.imageContainer}>
              <img
                className={S.image}
                alt=""
                src={imageUrl}/>
            </div>
            <Button
              icon="fak fa-lv-refresh"
              onClick={handleOpenCamera}>
              Retake
            </Button>
          </Flex>
        ) }
        <Text variant="label">Select Issue</Text>
        <div className={S.radioGroup}>
          { options.map( ( option ) => {
            const id = `${type}-${option.replace( /\s+/g, '-' ).toLowerCase()}`
            return (
              <label key={option} htmlFor={id} className={S.radioLabel}>
                <input
                  id={id}
                  type="radio"
                  value={option}
                  checked={selectedIssue === option}
                  onChange={e => setSelectedIssue( e.target.value )}
                  className={S.radioInput}/>
                {option}
              </label>
            )
          } )}
        </div>
      </Flex>
    </Dialog>
  )
}
